import { Home, GraduationCap, Banknote, FileText, Sparkles, Lightbulb, ShoppingBag, Brain, CalendarDays, Sprout, CircleCheckBig, FolderOpen, Hourglass, Bookmark, Gem, Pencil } from 'lucide-react';

// Fixed starter areas (per user's decision — editable areas come later)
export const AREAS = [
  { key: 'brain_dump', name: 'Brain Dump', icon: Brain, inbox: true },
  { key: 'ecru', name: '\u00c9CRU', icon: Sparkles },
  { key: 'home', name: 'Home', icon: Home },
  { key: 'nataniel', name: 'Nataniel', icon: GraduationCap },
  { key: 'money', name: 'Money', icon: Banknote },
  { key: 'life_admin', name: 'Life Admin', icon: FileText },
  { key: 'idea_vault', name: 'Idea Vault', icon: Lightbulb },
  { key: 'wishlist', name: 'Wishlist', icon: ShoppingBag },
  { key: 'this_month', name: 'This Month', icon: CalendarDays },
  { key: 'someday', name: 'Someday', icon: Sprout },
];

export const areaByKey = (key) => AREAS.find((a) => a.key === key) || null;

// Types: ideas must never compete visually with urgent tasks
export const TYPES = [
  { key: 'task', labelKey: 'cr_type_task', icon: CircleCheckBig, color: '#4a4540' },
  { key: 'idea', labelKey: 'cr_type_idea', icon: Lightbulb, color: '#C2B7AD' },
  { key: 'project', labelKey: 'cr_type_project', icon: FolderOpen, color: '#8B7355' },
  { key: 'waiting', labelKey: 'cr_type_waiting', icon: Hourglass, color: '#9A8C7E' },
  { key: 'decision', labelKey: 'cr_type_decision', icon: Gem, color: '#4F6B47' },
  { key: 'reference', labelKey: 'cr_type_reference', icon: Bookmark, color: '#8a847b' },
];

export const typeByKey = (key) => TYPES.find((t) => t.key === key) || null;

export const EVO_META = {
  created: { symbol: '\u2726', labelKey: 'cr_evo_created' },
  note: { symbol: '+', labelKey: 'cr_evo_note' },
  decision: { symbol: '\u2713', labelKey: 'cr_evo_decision' },
  moved: { symbol: '\u2192', labelKey: 'cr_evo_moved' },
  status: { symbol: '\u25cb', labelKey: 'cr_evo_status' },
  edit: { symbol: '\u270e', labelKey: 'cr_evo_edit' },
  project: { symbol: '\u2197', labelKey: 'cr_evo_project' },
  project_removed: { symbol: '\u2212', labelKey: 'cr_evo_project_removed' },
  completed: { symbol: '\u2713', labelKey: 'cr_evo_completed' },
  reopened: { symbol: '\u25cb', labelKey: 'cr_evo_reopened' },
  direction: { symbol: '\u25c7', labelKey: 'cr_evo_direction' },
};

export const fmtDateTime = (iso, locale = 'en-GB') => {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' })
    + ' \u00b7 ' + d.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
};

export const fmtDate = (iso, locale = 'en-GB') => {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString(locale, { day: 'numeric', month: 'short' });
};

export { Pencil };
